<button
  (click)="handleClick($event)"
  [ngClass]="{
    primary: variant == 'primary',
    secondary: variant == 'secondary',
    tertiary: variant == 'tertiary',
    darkMode: darkMode,
    loading: loading,
    disabled: disabled,
  }"
  [type]="type"
  [id]="idButton"
  [ngStyle]="{ 'width.px': width, 'height.px': height }"
>
  <img
    class="icone__imagem"
    *ngIf="hasIconEsquerdoImagem == true"
    [src]="hasIconEsquerdoImagem == true ? gerarIconeDeImagemEsquerdo() : ''"
    alt="Ícone esquerdo"
  />

  <i
    *ngIf="hasIconEsquerdo || loading"
    [class]="hasIconEsquerdo || loading ? gerarIcone() : ''"
    class="icone__fontawesome"
  ></i>

  {{ label }}

  <i
    *ngIf="hasIconDireito"
    [class]="hasIconDireito ? gerarIconeDireito() : ''"
    class="icone__fontawesome"
  ></i>

  <img
    class="icone__imagem"
    *ngIf="hasIconDireitoImagem == true"
    [src]="hasIconDireitoImagem == true ? gerarIconeDeImagemDireito() : ''"
    alt="Ícone esquerdo"
  />
</button>
